import React, { useEffect, useState } from "react";
import "./PopularServices.css"; // optional for extra styling
import Swal from "sweetalert2";
import storage from "../../utils/storage";
import LoginModal from "../Login/LoginModal";

const services = [
  {
    name: "Mobile Recharge",
    href: "/mobile-recharge",
    icon: "/assets/images/mobile-icon.png",
  },
  {
    name: "DTH Recharge",
    href: "/dth-recharge",
    icon: "/assets/images/dish-tv-icon.png",
  },
  {
    name: "FasTag Recharge",
    href: "/bill-payment/Fastag",
    icon: "/assets/images/fastag-logo.png",
  },
  {
    name: "Google Play Redeem Code",
    href: "/google-play-redeem-code",
    icon: "/assets/images/google-play-logo.png",
  },
  {
    name: "Postpaid Bill Pay",
    href: "/bill-payment/Postpaid",
    icon: "/assets/images/postpaid-icon.png",
  },
  // {
  //   name: "Credit Card",
  //   href: "/bill-payment/Credit Card",
  //   icon: "/assets/images/credit-card-icon.png",
  // },
  {
    name: "Loan/EMI Payment",
    href: "/bill-payment/Loan%20Repayment",
    icon: "/assets/images/loan-payment-icon.png",
  },
  {
    name: "Electricity Bill Pay",
    href: "/bill-payment/Electricity",
    icon: "/assets/images/electricity-bill-icon.png",
  },
  {
    name: "Landline Bill Pay",
    href: "/bill-payment/Landline",
    icon: "/assets/images/landline-icon.png",
  },
  {
    name: "Broadband",
    href: "/bill-payment/Broadband",
    icon: "/assets/images/broadband-icon.png",
  },
  {
    name: "Insurance",
    href: "/bill-payment/Insurance",
    icon: "/assets/images/insurance-icon.png",
  },
  {
    name: "Cable TV",
    href: "/bill-payment/Cable%20TV",
    icon: "/assets/images/cable-tv-icon.png",
  },
  {
    name: "Book Cylinder",
    href: "/bill-payment/LPG%20Booking",
    icon: "/assets/images/gas-cylinder-icon.png",
  },
  {
    name: "Piped Gas",
    href: "/bill-payment/Gas",
    icon: "/assets/images/gas-pipeline-icon.png",
  },
  {
    name: "Water",
    href: "/bill-payment/Water",
    icon: "/assets/images/water-bill-icon.png",
  },
];

const PopularServices = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Add logged in state

  useEffect(() => {
    checkLoginStatus();
  }, []);

  const checkLoginStatus = () => {
    // Retrieve access token and name from storage
    const token = storage.getAccessToken();
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleLoginClick = () => setShowModal(true);

  return (
    <div className="container my-4">
      <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-3">
        {services.map((service, index) => (
          <div className="col" key={index}>
            <a
              onClick={(e) => {
                if (!isLoggedIn) {
                  e.preventDefault(); // Prevent navigation
                  handleLoginClick();
                  return;
                }

                window.location.href = service.href;
              }}
              key={index}
              className="text-decoration-none flex-shrink-0"
              style={{ width: "100px" }}
            >
              <div className="border rounded p-2 text-center h-100 shadow-sm hover-effect">
                <img
                  src={service.icon}
                  alt={service.name}
                  className="mb-1"
                  width="32"
                />
                <div
                  className="fw-medium small"
                  style={{ fontSize: "14px", fontWeight: "450" }}
                >
                  {service.name}
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>

      <LoginModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onLoginSuccess={() => setIsLoggedIn(true)}
      />
    </div>
  );
};

export default PopularServices;
